import { render, staticRenderFns } from "./SorRelatedItemDetailDialog.vue?vue&type=template&id=042519cf"
import script from "./SorRelatedItemDetailDialog.vue?vue&type=script&lang=js"
export * from "./SorRelatedItemDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./SorRelatedItemDetailDialog.vue?vue&type=style&index=0&id=042519cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports